module.exports = __webpack_public_path__ + "img/small_back_arrow_black.ad238874.svg";